import $ from 'jquery';

const $sidemenuButton = $('.js-sidemenu-toggle');
const $body = $(document.body);
const toggleClass = 'sidemenu-open';
if ($sidemenuButton.length > 0) {
	$sidemenuButton.click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$body.toggleClass(toggleClass);
	});
}

$('.site-contents').on('click swiped-right', function () {
	$body.removeClass(toggleClass);
});

// $('.js-tabs a').on('click', function (e) {
// 	e.preventDefault();
// 	$(this).tab('show');
// });

$('.js-dropdown-hover').hover(function (e) {
	const $this = $(this);
	$this.toggleClass('show');
	$this.find('.dropdown-menu').toggleClass('show');
});
